import type { Pipeline } from '../../services/funnelApi';

type Props = {
  pipelines: Pipeline[];
  metrics: {
    openCount: number;
    openValue: number;
    wonCount: number;
    lostCount: number;
    overallConversion: number; // 0..1
    conversionByStage: Array<{ stageId: string; stageName: string; conversion: number; deals: number }>;
  };
};

/**
 * KPI cards. Mostra totais abertos/ganhos/perdidos e a conversão por stage
 * (ganhos ÷ total que passou pelo stage, aproximado pela contagem atual).
 */
export function FunnelMetrics({ metrics, pipelines }: Props) {
  const fmt = (v: number) =>
    v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
  const pct = (v: number) => `${Math.round(v * 100)}%`;

  return (
    <div className="funil-metrics" data-testid="funil-metrics" role="group" aria-label="Métricas do funil">
      <div className="funil-metric">
        <span className="text-xs text-xs">Negócios em aberto</span>
        <h4 className="text-base font-semibold" data-testid="metric-open-count">{metrics.openCount}</h4>
        <span className="text-xs text-kumo-subtle">Pipeline {pipelines.length > 0 ? pipelines[0].name : '—'}</span>
      </div>
      <div className="funil-metric">
        <span className="text-xs text-xs">Valor em aberto</span>
        <h4 className="text-base font-semibold" data-testid="metric-open-value">{fmt(metrics.openValue)}</h4>
        <span className="text-xs text-kumo-subtle">Somatório dos cards abertos</span>
      </div>
      <div className="funil-metric">
        <span className="text-xs text-xs">Ganhos</span>
        <h4 className="text-base font-semibold" data-testid="metric-won-count">{metrics.wonCount}</h4>
        <span className="text-xs text-kumo-subtle">Negócios no estágio Ganho</span>
      </div>
      <div className="funil-metric">
        <span className="text-xs text-xs">Perdidos</span>
        <h4 className="text-base font-semibold" data-testid="metric-lost-count">{metrics.lostCount}</h4>
        <span className="text-xs text-kumo-subtle">Negócios no estágio Perdido</span>
      </div>
      <div className="funil-metric">
        <span className="text-xs text-xs">Conversão geral</span>
        <h4 className="text-base font-semibold" data-testid="metric-conversion">{pct(metrics.overallConversion)}</h4>
        <span className="text-xs text-kumo-subtle">Ganhos ÷ (Ganhos + Perdidos)</span>
      </div>
    </div>
  );
}
